// 
// 绑定用户
// 
// 
<template>
  <div class="museruserbind">
    <div class="form_box__group__item">
        <div class="form_box__group__item__title">已绑定用户：</div>
        <div class="form_box__group__item__content">
          <template v-if="uid">
            <div class="font_base">
              {{uname}} {{partyorgname}}              
            </div>
          </template>
          <template v-else>
            <div class="font_base">
              该账号未绑定用户
            </div>
          </template>
        </div>
        <div class="form_box__group__item__tool">
            <el-button type="primary" @click="dobindedit">修改绑定用户</el-button>
        </div>
    </div>
    <div class="form_box__group__item mt-2" v-show="showedit">
        <div class="form_box__group__item__title">选择绑定用户：</div>
        <div class="form_box__group__item__content">
            <el-select
              v-model="optionid"              
              filterable
              remote
              reserve-keyword
              placeholder="可输入姓名进行搜索"
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                    <div class="museruserbind_userselect_option">
                      <div class="museruserbind_userselect_option_name">
                          <span style="float: left">{{ item.name }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.partyorgname }}</span>
                      </div>
                      <!-- <div v-if="item.unitname" class="museruserbind_userselect_option_unit">
                          {{item.unitname}}
                      </div>
                      <div v-if="item.partyorgname" class="museruserbind_userselect_option_partyorg">
                          {{item.partyorgname}}
                      </div> -->
                    </div>
              </el-option>
            </el-select>
        </div>
        <div class="form_box__group__item__tool">
            <el-button type="primary" @click="doUpdate" :loading="editloading">更新</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { optionsApi } from "@/api/module/user/user";
import { muserBindUserApi, muserBindUserInitApi } from "@/api/module/muser/muser";

export default {
  name: "MuserUserBind",
  
  mixins: [BaseVue],
  
  data() {
    return {
      muid: "",  // muser.id
      uid: "",   // 绑定的用户
      uname: "",
      partyorgname: "",
      optionid: "",
      loading: false,
      editloading: false,
      options: [],   // options
      showedit: false
    };
  },
  
  methods: {
    // 远程搜索options
    remoteMethod(query) {
      this.loading = true;
      optionsApi(query)
        .then((response) => {
          console.log("options", response);
          this.options = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 初始化
    init() {
      this.showedit = false;
      
      muserBindUserInitApi(this.muid)
        .then((response) => {
          console.log("options", response);
          if (response) {
            this.uid = response.id;
            this.uname = response.name;
            this.partyorgname = response.partyorgname;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    doUpdate() {
      this.editloading = true;
      muserBindUserApi(this.optionid, this.muid)
        .then((r) => {
          this.$message({
            message: '绑定成功',
            type: 'success'
          });
          this.init();
        })
        .finally(() => {
          this.editloading = false;
        });
    },
    
    initMUid(muid) {
      this.muid = muid;
    },
    
    dobindedit() {
      this.showedit = !this.showedit;
    }
  },
  
  mounted() {
    // this.init();
  }
};
</script>

<style scoped lang="scss">
.museruserbind {

  .museruserbind_userselect_option{

    display: flex;
    flex-wrap: nowrap ; // 换行 nowrap | wrap | wrap-reverse
    flex-direction:row; //| row-reverse | column | column-reverse;
    justify-content:  flex-start; // 定义了项目在主轴上的对齐方式 flex-start | flex-end | center | space-between | space-around;
    align-items:  flex-start; // | flex-end | center | baseline | stretch;
  }

}
</style>